<modal>
  <span header class="uppercase">{{'Tồn cuối mã' | lang}} {{SKU}} <span *ngIf="color">{{'màu' | lang}} {{color}}</span> ({{range.name}})</span>

  <text-filter [target]="details" class="std-margin-bottom" [placeholder]="'Tìm đơn'"></text-filter>

  <table responsive class="data">
    <tr>
      <th priority="6" class="text-right" style="width: 0">STT</th>
      <th priority="1"><sortable [target]="details" [extractor]="extractor('Tag')">{{'Đơn nhập' | lang}}</sortable></th>
      <th priority="3" class="text-right"><sortable [target]="details" [extractor]="extractor('LengthQuantity')">{{'Hàng mét' | lang}}</sortable></th>
      <th priority="5" class="text-right"><sortable [target]="details" [extractor]="extractor('WeightQuantity')">{{'Hàng cân' | lang}}</sortable></th>
      <th priority="5" class="text-right"><sortable [target]="details" [extractor]="extractor('ReducedQuantity')">{{'Khấu trừ' | lang}}</sortable></th>
      <th priority="4" class="text-right"><sortable [target]="details" [extractor]="extractor('QuoteQuantity')">{{'Tính tiền' | lang}}</sortable></th>
      <th priority="4" class="text-right"><sortable [target]="details" [extractor]="extractor('Price')">{{'Giá nhập' | lang}}</sortable></th>
      <th priority="2" class="text-right"><sortable [target]="details" [extractor]="extractor('Subtotal')">{{'Thành tiền' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of details.pageMatches; index as ix" class="text-top">
      <td><small>{{ix + 1 + details.pageIndex * details.pageSize}}</small></td>
      <td>
        <invoice [tag]="i.Path[0]" [displays]="{partner: true}" (unconfirmed)="unconfirmed($event)" [filters]="{ sku: SKU, color: color, importTag: i.Path[0], exportAfter: range }"></invoice>
      </td>
      <td>
        <span class="text-success">{{i.Initial.LengthQuantity | number : '1.1-1' : 'en-US'}}</span><m></m>
        <br />
        <small><b class="text-success">{{i.Initial.LengthCount | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit></small>
      </td>
      <td>
        <span class="text-success">{{i.Initial.WeightQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg>
        <br />
        <small><b class="text-success">{{i.Initial.WeightCount | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit></small>
      </td>
      <td>
        <div><span class="text-danger">{{i.Initial.LengthQuantity - i.Initial.LengthQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div><span class="text-danger">{{i.Initial.WeightQuantity - i.Initial.WeightQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
      <td>
        <div><span class="text-success">{{i.Initial.LengthQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div><span class="text-success">{{i.Initial.WeightQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
      <td>
        {{i.Initial.BaseWorth / (i.Initial.LengthQuoteQuantity + i.Initial.WeightQuoteQuantity) | number : '1.1-1' : 'en-US'}}
        <cny-per-unit [type]="i.Initial.LengthCount > 0 ? (i.Initial.WeightCount > 0 ? 0 : 1) : 2"></cny-per-unit>
      </td>
      <td>
        <b class="text-danger">{{i.Initial.BaseWorth | number : '1.1-1' : 'en-US'}}</b><cny></cny>
      </td>
    </tr>

    <tr *ngIf="details.pages.length > 1">
      <td [colSpan]="8" style="display: table-cell !important" class="text-center"><pagination [target]="details"></pagination></td>
    </tr>

    <tr class="footer bold" *ngIf="details.matches.length > 1">
      <td></td>
      <td>{{'TỔNG' | lang}} ({{details.matches.length}})</td>
      <td>
        <div>{{sum('LengthQuantity') | number : '1.1-1' : 'en-US'}}<m></m></div>
        <small>{{sum('LengthCount') | number : '1.0-0' : 'en-US'}}<unit>cây</unit></small>
      </td>
      <td>
        <div>{{sum('WeightQuantity') | number : '1.1-1' : 'en-US'}}<kg></kg></div>
        <small>{{sum('WeightCount') | number : '1.0-0' : 'en-US'}}<unit>cây</unit></small>
      </td>
      <td>
        <div>{{sum('ReducedLength') | number : '1.1-1' : 'en-US'}}<m></m></div>
        <div>{{sum('ReducedWeight') | number : '1.1-1' : 'en-US'}}<kg></kg></div>
      </td>
      <td>
        <div>{{sum('LengthQuoteQuantity') | number : '1.1-1' : 'en-US'}}<m></m></div>
        <div>{{sum('WeightQuoteQuantity') | number : '1.1-1' : 'en-US'}}<kg></kg></div>
      </td>
      <td>
        {{sum('Subtotal') / (sum('LengthQuoteQuantity') + sum('WeightQuoteQuantity'))  | number : '1.1-1' : 'en-US'}}
        <cny-per-unit [type]="sum('LengthCount') > 0 ? (sum('WeightCount') > 0 ? 0 : 1) : 2"></cny-per-unit>
      </td>
      <td>{{sum('Subtotal') | number : '1.1-1' : 'en-US'}}<cny></cny></td>
    </tr>
  </table>
</modal>
